import styled from 'styled-components';

export const PanelBody = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex-grow: 1;
  font-family: Poppins;
`;

export const StyleGroup = styled.div`
  margin-bottom: 25px;
`;

export const GroupTitle = styled.h4`
  margin: 0 0 10px 0;
  font-weight: 500;
`;

export const SettingsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  align-items: center;
  margin-bottom: 10px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Label = styled.label`
  margin-bottom: 4px;
  font-weight: 500;
`;

export const Input = styled.input`
  width: 100%;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const Select = styled.select`
  width: 100%;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 30px;
  font-size: 1.2rem;
`;

// Specific row for the font styler
export const FontStylingRow = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  margin-bottom: 10px;

  & > ${Label}:first-child {
    flex-basis: 150px;
    flex-shrink: 0;
  }

  & > ${Select} {
    width: 70px; 
    flex-shrink: 0; 
  }
`;

export const FontStyleToggles = styled.div`
  display: flex;
  gap: 5px;
`;

export const ToggleButton = styled.button`
  && {
    border: none;
    background-color: ${({ isActive }) => (isActive ? '#7A9F3F' : '#f1f1f1')};
    color: ${({ isActive }) => (isActive ? 'white' : '#333')};
    padding: 4px;
    width: 25px;
    height: 25px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;